import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss'


const BodyContent = ({ value, onChange }) => (
  <textarea
    className={`p-2 form-control ${styles.textArea}`}
    value={value}
    onChange={onChange}
    rows={10}
  />
);

BodyContent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default BodyContent;


// WEBPACK FOOTER //
// src/components/emailLayout/BodyContent/index.jsx